<template>
  <a
    :class="classes()"
    href="https://www.tuev-saar.de/zertifikat/sc45270/"
    rel="noopener"
    target="_blank"
  >
    <img src="https://mailing-assets.pflege.de/tuev/tuev_big.png" width="194" height="102" />
  </a>
</template>

<script>
export default {
  name: 'TuevCertificate',
  props: {},
  data() {
    return {
      el: 'o-tuevCertificate',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
    };
  },
};
</script>
